// This file is generated by Slice Machine. Update with care!

import ModuleSections from './ModuleSections';

export { ModuleSections };

export const components = {
  module_sections: ModuleSections,
};
